import { useState } from "react";

import { css } from "@emotion/react";

import { useRouter } from "next/router";

import { NewDocModal } from "components/documents/NewDocModal";
import { MediaUploader } from "components/shared/library/MediaUploader";
import { RibbonProWidget } from "components/shared/ribbonPro/RibbonProWidget";


import { getDocumentsListUrl } from "utils/urls";

import {
  documentAcceptedFileTypes,
  documentFileTypeString,
  maxDocumentSizeInMb,
} from "constants/files";

const style = {
  slider: css({
    display: "flex",
    gap: 16,
  }),
  dropUpload: css({
    height: 46,
  }),
};

export const ResumeReviewWidget = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [initialFiles, setInitialFiles] = useState<File[]>([]);
  const router = useRouter();

  return (
    <RibbonProWidget
      title={"Resume+"}
      description="Put your best resume forward"
    >
      <MediaUploader
        customCss={{ dropUpload: style.dropUpload }}
        onChange={(files) => {
          setInitialFiles(files);
          setIsUploadModalOpen(true);
        }}
        acceptedFileTypes={documentAcceptedFileTypes}
        fileTypeString={documentFileTypeString}
        maxSizeInMb={maxDocumentSizeInMb}
        multiple
      />
      <NewDocModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        initialFiles={initialFiles}
        onDone={() => router.push(getDocumentsListUrl())}
      />
    </RibbonProWidget>
  );
};
